<template>
  <AuthTemplate type="register">
    <h1>Регистрация</h1>
    <button-component
      variant="filled"
      mb="20px"
      type="link"
      @click="openModal('register_client')"
    >Я клиент</button-component>
    <button-component
      variant="filled"
      type="link"
      @click="openModal('register_master')"
    >Я мастер</button-component>
  </AuthTemplate>
</template>

<script>
  import AuthTemplate from '../../../templates/AuthTemplate'
  import ButtonComponent from '@/components/ui/buttons/button-component'
  import { mapMutations } from 'vuex'

  export default {
    name: 'Register_Main',
    components: {ButtonComponent, AuthTemplate},
    methods: mapMutations(['openModal'])
  }
</script>

<style scoped>

</style>